// src/components/UI/components/DropdownMenu/DropdownMenuSubMenuContent.tsx

import { Portal, SubContent } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cx } from '../../lib/utils';

const DropdownMenuSubMenuContent = forwardRef<
  React.ElementRef<typeof SubContent>,
  React.ComponentPropsWithoutRef<typeof SubContent>
>(({ className, collisionPadding = 8, ...props }, forwardedRef) => (
  <Portal>
    <SubContent
      ref={forwardedRef}
      collisionPadding={collisionPadding}
      className={cx(
        // base
        'relative z-50 overflow-hidden rounded-md border p-1 shadow-xl shadow-black/[2.5%]',
        // widths
        'min-w-32',
        // heights
        'max-h-[var(--radix-popper-available-height)]',
        // background color
        'bg-white dark:bg-[#090E1A]',
        // text color
        'text-gray-900 dark:text-gray-50',
        // border color
        'border-gray-200 dark:border-gray-800',
        // transition
        'will-change-[transform,opacity]',
        // 'data-[state=open]:animate-slideDownAndFade',
        'data-[state=closed]:animate-hide',
        'data-[side=bottom]:animate-slideDownAndFade data-[side=left]:animate-slideLeftAndFade data-[side=right]:animate-slideRightAndFade data-[side=top]:animate-slideUpAndFade',
        className,
      )}
      {...props}
    />
  </Portal>
));
DropdownMenuSubMenuContent.displayName = 'DropdownMenuSubMenuContent';

export { DropdownMenuSubMenuContent };
